import React, { useEffect, useState } from "react";
import { Progress } from "reactstrap";

import LoadingGif from "../../../assets/images/market/loading.gif";
import s from "./MarketPage.module.scss";

export default function MarketLoading() {
	const [downloadProgress, setDownloadProgress] = useState(0);

	// ------------------------------------- INIT -------------------------------------
	useEffect(() => {
		let timer;
		const updateProgress = () => setDownloadProgress(downloadProgress + 5);
		if (downloadProgress < 100) {
			timer = setTimeout(updateProgress, 100);
		}

		return () => {
			clearTimeout(timer);
		};
	}, [downloadProgress]);

	return (
		<div className={s.loading}>
			<img src={LoadingGif} alt="loading" />

			<div className={s.progress}>
				<Progress value={downloadProgress} color={"info"} />
			</div>
		</div>
	);
}
